import { render, staticRenderFns } from "./ClaimPaymentsCard.vue?vue&type=template&id=be589db6&scoped=true&lang=pug&"
import script from "./ClaimPaymentsCard.vue?vue&type=script&lang=js&"
export * from "./ClaimPaymentsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be589db6",
  null
  
)

export default component.exports